import { gql, TypedDocumentNode } from '@apollo/client'

export type Banner = {
  id: string
  order: number
  level: {
    code: string
    description: string
  }
  scope: {
    code: string
    description: string
  }
  metadata: {
    styles: {
      key: string
      value: string
    }[]
  }
  header: string
  message: string
  adminNotes?: string
  startAt?: string
  endAt?: string
  platform?: string[]
}

export interface GetActiveBannersData {
  getActiveBanners: Banner[]
}

export const GET_ACTIVE_BANNERS: TypedDocumentNode<GetActiveBannersData> = gql`
  query getActiveBanners {
    getActiveBanners {
      id
      order
      level {
        code
        description
      }
      scope {
        code
        description
      }
      metadata {
        styles {
          key
          value
        }
      }
      header
      message
      adminNotes
      startAt
      endAt
      platform
    }
  }
`
